export enum MappingType {
  TEXT = "text",
  NUMBER = "number",
  INT = "int",
  DECIMAL = "decimal",
}

export interface MappingDTO {
  tool: string;
  key: string;
  active: boolean;
  type: MappingType;
  icon: string;
  label: string;
  description: string | null;
  identity: boolean;
  comparable: boolean;
  sortable: boolean;
  searchable: boolean;
  filterable: boolean;
  requires_subscription: boolean;
}
